import { useMutation } from 'react-query';
import axios from 'axios';
import { CategoriesTopicsTableAPI } from '../../../constants/API';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { QueueItemIconMedia } from '../../../types/Admin/ItemIconTypes';

export const useUploadCategoryIcon = (categoryId?: number | null) => {
  const { mutateAsync: uploadCategoryIcon, isLoading: isUploadCategoryIconLoading } = useMutation(
    async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const url = categoryId
        ? CategoriesTopicsTableAPI.uploadCategoryIcon(categoryId)
        : CategoriesTopicsTableAPI.uploadPendingCategoryIcon;
      const response = await axios.post<QueueItemIconMedia>(url, formData, multipartHeaders());
      return response.data.url;
    }
  );

  return { uploadCategoryIcon, isUploadCategoryIconLoading };
};
